import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useRouteError } from "react-router";

import { globalData } from "@/data";
import { hideOfflineView, showOfflineView } from "@/redux/actions";
import { store } from "@/redux/store";
import * as types from "@/redux/types";
import { removeCookie } from "@/utils";
import { ErrorView, OfflineView } from "@/views";

export const ErrorBoundary = () => {
    const dispatch = useDispatch();

    const navigate = useNavigate();

    const error = useRouteError();

    const is401 = error?.response?.status === 401 || error?.status === 401;

    const isNetworkError = error?.message?.toLowerCase().includes("failed to fetch") || error?.message?.toLowerCase().includes("network") || error?.message?.toLowerCase().includes("load failed"); // eslint-disable-line code-style/no-hardcoded-strings

    const shouldShowOfflineView = !navigator.onLine && isNetworkError;

    useEffect(
        () => {
            if (is401) {
                store.dispatch({ type: types.USER_LOG_OUT_SUCCESS });

                removeCookie(globalData.cookieKeys.token);

                removeCookie(globalData.cookieKeys.user);

                navigate(
                    "/auth/login",
                    { replace: true },
                );
            }
        },
        [is401],
    );

    useEffect(
        () => {
            if (shouldShowOfflineView) dispatch(showOfflineView());

            return () => dispatch(hideOfflineView());
        },
        [shouldShowOfflineView, dispatch],
    );

    if (is401) return null;

    if (shouldShowOfflineView) return <OfflineView />;

    return <ErrorView />;
};
